import React from "react";
import "./progressBar.scss";
export const ProgressBar = ({ barWidth, barMinWidth, progressCount }) => {
  return (
    <div className="progress-bar-wrapper">
      <div className={`progress-bar ${barWidth === "0%" ? "loading" : ""}`}>
        <span
          className="progress-move"
          style={{ width: barWidth, minWidth: barMinWidth }}
        >
          <span>{`${
            progressCount > 0 ? `${Math.round(progressCount)}%` : " "
          }`}</span>
        </span>
      </div>
      {/* {progressCount && (
        <div>
          <p className="text-center">{`${Math.round(progressCount)}%`}</p>
        </div>
      )} */}
    </div>
  );
};
